// import { useEffect, useState } from "react";
// import {
//   Dropdown,
//   DropdownItem,
//   DropdownMenu,
//   DropdownToggle,
// } from "reactstrap";
// import { FaChevronDown, FaChevronUp } from "react-icons/fa";

// interface OptionType {
//   id: number | string;
//   label: string;
// }

// interface DropdownProps {
//   options: OptionType[] | string[];
//   onSelect?: (value: OptionType | string) => void;
//   value?: number | string; // New value prop
//   width?: string;
//   height?: string;
//   backgroundColor?: string;
//   DropdownHeading?: string;
//   headingColor?: string;
//   borderRadius?: string;
//   sideDropdownHeading?: string;
//   label?: string;
//   heading?: string;
//   border?: string;
//   disabled?: boolean;
// }

// const ReusableDropdown: React.FC<DropdownProps> = ({
  
//   options = [
//     { id: 1, label: "Option 1" },
//     { id: 2, label: "Option 2" },
//     { id: 3, label: "Option 3" },
//   ],
  
//   onSelect = () => {},
//   disabled = false,
//   label = "Select",
//   width = "100%",
//   height,
//   backgroundColor,
//   DropdownHeading,
//   sideDropdownHeading,
//   headingColor,
//   borderRadius = "8px",
//   border = "2px solid #EDEDED",
// }) => {
//   const [open, setOpen] = useState(false);
//   const [selected, setSelected] = useState<string>(label);

//   useEffect(()=>{
//     setSelected(label)
//   },[label])

//   const toggle = () =>{
//     if(!disabled){
//       setOpen(!open);
//     }
//   } 
    

//   const handleSelect = (option: OptionType | string) => {
//     setSelected(typeof option === "string" ? option : option.label);
//     onSelect(option);
//   };

//   return (
//     <div style={{ width: "100%" }}>
//       {DropdownHeading && (
//         <label
//           style={{
//             fontWeight: "500",
//             marginBottom: "6px",
//             display: "block",
//             marginTop: "10px",
//           }}
//         >
//           {DropdownHeading}
//         </label>
//       )}
//       <Dropdown isOpen={open} toggle={toggle} style={{ width }}>
//         {sideDropdownHeading && (
//           <p
//             style={{
//               display: "flex",
//               alignItems: "center",
//               color: headingColor,
//               marginRight: "5px",
//               fontWeight: "500",
//               marginLeft: "5px",
//               justifyContent: "center",
//               width: "100%",
//             }}
//           >
//             {sideDropdownHeading}
//           </p>
//         )}
//         <DropdownToggle
//         color=""
//         disabled={disabled} 
//           style={{
//             backgroundColor,
//             color: "#767676",
//             padding: "11px",
//             fontSize: "13px",
//             width: "100%",
//             textAlign: "left",
//             boxShadow: "none",
//             fontWeight: "400",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             height,
//             borderRadius,
//             border,
//           }}
//         >
//           {selected}
//           {open ? (
//             <FaChevronUp size={14} style={{ marginLeft: "10px" }} />
//           ) : (
//             <FaChevronDown size={14} style={{ marginLeft: "10px" }} />
//           )}
//         </DropdownToggle>
//         <DropdownMenu
//           style={{
//             width: "100%",
//             border: "1px solid #EDEDED",
//             padding: "5px 0",
//             maxHeight: "150px",
//             overflowY: "auto",
//           }}
//         >
//           {options.map((option) => (
//             <DropdownItem
//               key={typeof option === "string" ? option : option.id}
//               style={{
//                 padding: "10px 15px",
//                 fontSize: "14px",
//                 cursor: "pointer",
//               }}
//               onClick={() => handleSelect(option)}
//             >
//               {typeof option === "string" ? option : option.label}
//             </DropdownItem>
//           ))}
//         </DropdownMenu>
//       </Dropdown>
//     </div>
//   );
// };

// export default ReusableDropdown;








import { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

interface OptionType {
  id: number | string;
  label: string;
}

interface DropdownProps {
  options: OptionType[] | string[];
  onSelect?: (value: OptionType | string) => void;
  value?: number | string |null;
  width?: string;
  height?: string;
  backgroundColor?: string;
  DropdownHeading?: string;
  headingColor?: string;
  borderRadius?: string;
  sideDropdownHeading?: string;
  label?: string;
  heading?: string;
  border?: string;
  disabled?: boolean;
}

const ReusableDropdown: React.FC<DropdownProps> = ({
  options = [
    { id: 1, label: "Option 1" },
    { id: 2, label: "Option 2" },
    { id: 3, label: "Option 3" },
  ],
  onSelect = () => {},
  value,
  disabled = false,
  label = "Select",
  width = "100%",
  height,
  backgroundColor,
  DropdownHeading,
  sideDropdownHeading,
  headingColor,
  borderRadius = "8px",
  border = "2px solid #EDEDED",
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string>(label);

  useEffect(() => {
    if (value !== undefined) {
      const selectedOption =
        typeof value === "string"
          ? value
          : (options.find(
              (opt) => typeof opt !== "string" && opt.id === value
            ) as OptionType | undefined)?.label;

      if (selectedOption) {
        setSelected(selectedOption);
      }
    } else {
      setSelected(label);
    }
  }, [value, label, options]);

  const toggle = () => {
    if (!disabled) {
      setOpen(!open);
    }
  };

  const handleSelect = (option: OptionType | string) => {
    setSelected(typeof option === "string" ? option : option.label);
    onSelect(option);
  };

  return (
    <div style={{ width: "100%" }}>
      {DropdownHeading && (
        <label
          style={{
            fontWeight: "500",
            marginBottom: "6px",
            display: "block",
            marginTop: "10px",
          }}
        >
          {DropdownHeading}
        </label>
      )}
      <Dropdown isOpen={open} toggle={toggle} style={{ width }}>
        {sideDropdownHeading && (
          <p
            style={{
              display: "flex",
              alignItems: "center",
              color: headingColor,
              marginRight: "5px",
              fontWeight: "500",
              marginLeft: "5px",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {sideDropdownHeading}
          </p>
        )}
        <DropdownToggle
          color=""
          disabled={disabled}
          style={{
            backgroundColor,
            color: "#767676",
            padding: "11px",
            fontSize: "13px",
            width: "100%",
            textAlign: "left",
            boxShadow: "none",
            fontWeight: "400",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height,
            borderRadius,
            border,
          }}
        >
          {selected}
          {open ? (
            <FaChevronUp size={14} style={{ marginLeft: "10px" }} />
          ) : (
            <FaChevronDown size={14} style={{ marginLeft: "10px" }} />
          )}
        </DropdownToggle>
        <DropdownMenu
          style={{
            width: "100%",
            border: "1px solid #EDEDED",
            padding: "5px 0",
            maxHeight: "150px",
            overflowY: "auto",
          }}
        >
          {options.map((option) => (
            <DropdownItem
              key={typeof option === "string" ? option : option.id}
              style={{
                padding: "10px 15px",
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() => handleSelect(option)}
            >
              {typeof option === "string" ? option : option.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default ReusableDropdown;
